import { useLocalizedNameTranslate } from "hooks/useLocalizedNameTranslate";
import {
  UNRESOLVED_VARIABLE_DEFAULT,
  UNRESOLVED_VARIABLE_KEY,
} from "tools/task/unresolvedVariable";

/** Exhibitor-facing label for an unresolved variable; `undefined` = English. */
const useUnresolvedVariableLabel = (): string | undefined => {
  const t = useLocalizedNameTranslate();
  return t
    ? t(UNRESOLVED_VARIABLE_KEY, UNRESOLVED_VARIABLE_DEFAULT)
    : undefined;
};

export default useUnresolvedVariableLabel;
